export default __webpack_public_path__ + "static/vakantiediscounter-04c1416ec9478fd555ac922dc4336b70.png";